// extracted by mini-css-extract-plugin
export var chevron = "_lx-2";
export var chevronRotated = "_lx-3";
export var header = "_lx-1";
export var section = "_lx-0";